import { sendWebsocketMessage } from '../../../../../../App';
import pako from 'pako';

export function addSavedTradePlanConfig(configTitle, tradePlanJson, templateType) {
  const messageObject = {
    messageType: 'addSavedTradePlanConfiguration',
    configurationName: configTitle,
    tradePlanJson: {
      json: {
        ...tradePlanJson,
        ...(templateType ? { templateType } : {}),
      },
    },
  };
  const message = JSON.stringify(messageObject);
  if (new Blob([message]).size > 7500) {
    //think max size is 8192
    console.log(message.length);
    console.log('message too large: ' + new Blob([message]).size + '. zipping');
    const compressed = pako.gzip(message);
    //  console.log(compressed);
    console.log(compressed.length);
    sendWebsocketMessage(compressed);

    //alert("websocket message is too long.")
  } else {
    sendWebsocketMessage(messageObject);
  }
}
